"use client";
import React from "react";
import styles from "../styles/home.module.css"
import { useNavigate } from "react-router-dom";


  const Card = ({flat}) => {
    const navigate = useNavigate();
    // const [openDetails, setDetails] = useState(false);

    const handleClick = () => {
      navigate(`/search-listings/apartments/${flat.id}`);
    }

    return(
      <>
        <div className={styles.FlatCard} onClick={() => handleClick()}>

              <img src= {flat.imageSources[0]} alt="flat image"></img>

              <div className={styles.CardDetails}>
                <h3><b>৳</b>{flat.costBreakdown.main.monthly.required[0].value} /mo</h3>
                <p>{flat.subtitle}</p>  
                <div className={styles.tags}> 
                  {flat.additionals.map( (item, index) => (
                    
                    <div key={index} className={styles.additionalInfo}>
                    <p> {item.roomDetails} </p>
                    <p> <b>{item.additionalValue} </b> </p>
                  </div>
                  ))}
                </div>

            </div>
        </div>
      </>
    );


  }

  export default Card;